import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRocket = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3018_125378)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.55533 13.997C8.34071 13.1213 7.9138 12.2965 7.418 11.5467L7.37302 11.5323C7.02733 11.7601 6.68806 11.7819 6.35239 11.52L2.47855 7.64712C2.23798 7.33406 2.24723 6.9498 2.46621 6.62698L2.45182 6.582C1.71391 6.079 0.901976 5.69346 0.0427503 5.44568C0.0090804 5.43591 -0.00865413 5.46599 0.00419698 5.4061C0.0437784 5.2213 0.291291 4.81956 0.409264 4.65892C1.43607 3.26095 3.24319 3.1291 4.81874 3.51155C6.76748 1.63603 9.31071 0.440083 12.001 0.0936106C12.3672 0.0465747 13.156 -0.0621477 13.4794 0.0470887C13.6598 0.108004 13.8654 0.3072 13.9371 0.481978C14.0708 0.807631 13.9569 1.62421 13.9083 2.00049C13.5621 4.69028 12.3626 7.23073 10.4892 9.18028C10.53 9.4972 10.6241 9.80537 10.657 10.1243C10.8089 11.5948 10.3545 12.9781 9.05318 13.761C8.99304 13.7973 8.58591 14.0296 8.55481 13.997H8.55533ZM9.95944 2.08377C9.23849 2.18144 8.61855 2.87156 8.55558 3.58841C8.40522 5.29918 10.5591 6.14608 11.5915 4.7805C12.5184 3.55448 11.4736 1.87841 9.9597 2.08377H9.95944Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.58367 8.8733L5.12639 11.4153C4.3872 12.1386 3.46012 12.6817 2.44462 12.9115C1.97145 13.0184 1.48002 13.1492 1.14203 12.6981C0.8809 12.3496 0.994504 11.9677 1.08138 11.5772C1.31038 10.5501 1.85476 9.621 2.58342 8.87305L2.58367 8.8733Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125378",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgRocket;
